import type { TriggerDagRequest } from '@/entities/dag';

import type { DagTableRow } from '@/features/dag-list/model/types';

export const buildDagRowTriggerRequest = (record: DagTableRow): TriggerDagRequest | null => {
  if (record.selectedVersion != null) {
    return {
      dagUuid: record.dagUuid,
      version: record.selectedVersion,
    };
  }

  if (record.hasDeployment) {
    return {
      dagUuid: record.dagUuid,
      deployed: true,
    };
  }

  return null;
};
